// Cómo tiene que ser la foto del producto, en "Tu producto" arriba del botón de subir, cuando
// hay que subir una (sin tienda conectada). Son los ejemplos por rubro del cuestionario de siempre
// (ADR-2026-08-01-instrucciones-de-foto-por-rubro): el producto solo y el producto en uso.

import CachedImg from '../../CachedImg';
import { getInstructionExamples, RUBRO_POR_CATEGORIA } from '../accountSetup';

/** El rubro de la marca ("Moda e Indumentaria") a la categoría de los ejemplos ("moda"). */
function categoriaDelRubro(rubro: string): string {
  return Object.keys(RUBRO_POR_CATEGORIA).find((k) => RUBRO_POR_CATEGORIA[k] === rubro) ?? 'otros';
}

export function EjemplosDeFoto({ rubro }: { rubro: string }) {
  const ejemplos = getInstructionExamples([categoriaDelRubro(rubro)]);
  return (
    <figure className="om-ejemplos" aria-label="Ejemplos de una buena foto de producto">
      <figcaption className="om-ejemplos__texto">
        Así funciona mejor: el producto completo, solo o en uso, con buena luz y un fondo simple.
        {ejemplos.tip ? ` ${ejemplos.tip}` : ''}
      </figcaption>
      <div className="om-ejemplos__fotos">
        {[ejemplos.solo, ejemplos.enUso].map((src, i) => (
          <span key={src} className="om-ejemplos__foto">
            <CachedImg src={src} alt={i === 0 ? 'Ejemplo: el producto solo' : 'Ejemplo: el producto en uso'} draggable={false} />
            <span className="om-ejemplos__tilde material-symbols-rounded" aria-hidden="true">
              check
            </span>
          </span>
        ))}
      </div>
    </figure>
  );
}

export default EjemplosDeFoto;
